import {
  Modal,
  ModalContent,
  ModalHeader,
} from '@fountain/fountain-ui-components';
import React, { VFC } from 'react';

export interface ViewScorecardModalProps {
  applicantId: string;
  scorecardTemplateId: string;
  scorecardName: string;
  handleClose: () => void;
}

// The pending and submitted scorecard guidelines arrive with a follow-up
// ticket; this shell owns the open/close plumbing and the context they need.
export const ViewScorecardModal: VFC<ViewScorecardModalProps> = ({
  applicantId,
  scorecardTemplateId,
  scorecardName,
  handleClose,
}) => (
  <Modal
    data-testid="view-scorecard-modal"
    ariaLabelledBy="view-scorecard-modal-header"
    open
    onClose={handleClose}
    fullScreenOnMobile
    maxWidth={860}
  >
    <ModalHeader
      onClose={handleClose}
      ariaLabelledBy="view-scorecard-modal-header"
      showIcon={false}
    >
      {scorecardName}
    </ModalHeader>
    <ModalContent
      data-applicant-id={applicantId}
      data-scorecard-template-id={scorecardTemplateId}
    />
  </Modal>
);
